import { Component, inject } from '@angular/core';
import { WorkFrontTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  WorkFrontTypeCreateDto,
  WorkFrontTypeDto,
  WorkFrontTypeExcelDownloadDto,
  WorkFrontTypeUpdateDto,
} from '../proxy/controlling/dtos/work-front-type';
import { WORKFRONTTYPE_CONFIG, WORKFRONTTYPE_FIELDS } from './work-front-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-work-front-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, WorkFrontTypeService, ConfirmationService],
  templateUrl: './work-front-type.html',
  styleUrl: './work-front-type.scss',
})
export class WorkFrontType extends BaseCrudComponent<
  WorkFrontTypeDto,
  WorkFrontTypeCreateDto,
  WorkFrontTypeUpdateDto,
  WorkFrontTypeExcelDownloadDto
> {
  service = inject(WorkFrontTypeService);
  config = WORKFRONTTYPE_CONFIG;
  fields = WORKFRONTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: WorkFrontTypeDto): WorkFrontTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      quantityHv: data.quantityHv,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'WorkFrontType';
  }
}
